import { useCallback, useEffect, useState } from "react";
import clinicAPI from "../../../services/clinicApi";
import { useToast } from "../../ui";
import { HubFormCard } from "../AdminPortal/HubPwa";
import s from "../clinic.module.css";
import md from "../common/manageDesktop.module.css";

const TRAINER_NOTIFY_LEAD =
  "Каждый вечер в 18:00 на email тренера приходит список занятий на следующий день: время, клиенты и услуги. Письмо отправляется один раз в сутки, если на завтра есть записи.";

export default function TrainerNotifySettingsPanel({ compact = false }) {
  const toast = useToast();
  const [trainers, setTrainers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await clinicAPI.getDoctors({ include_summary: "false" });
      setTrainers((data.doctors || []).filter((d) => d.is_active !== false));
    } catch (e) {
      toast.error(e.response?.data?.error || "Не удалось загрузить тренеров");
      setTrainers([]);
    } finally {
      setLoading(false);
    }
  }, [toast]);

  useEffect(() => {
    load();
  }, [load]);

  const setNotify = async (id, value) => {
    setBusyId(id);
    try {
      await clinicAPI.updateDoctor(id, { notify_appointments: value });
      setTrainers((rows) =>
        rows.map((t) => (t.id === id ? { ...t, notify_appointments: value } : t)),
      );
    } catch (e) {
      toast.error(e.response?.data?.error || "Ошибка сохранения");
    } finally {
      setBusyId(null);
    }
  };

  const body = loading ? (
    <p className={s.summaryEmptyNote}>Загрузка…</p>
  ) : trainers.length === 0 ? (
    <p className={s.summaryEmptyNote}>Нет активных тренеров</p>
  ) : (
    <>
      <p className={compact ? s.onboardingSheetHint : md.desktopGroupSettingsLead}>
        {TRAINER_NOTIFY_LEAD}
      </p>
      <ul className={s.trainerNotifyList}>
        {trainers.map((t) => (
          <li key={t.id} className={s.trainerNotifyRow}>
            <label className={s.settingsToggleRow}>
              <input
                type="checkbox"
                checked={t.notify_appointments !== false}
                disabled={busyId === t.id}
                onChange={(e) => setNotify(t.id, e.target.checked)}
              />
              <span>
                <strong>{t.full_name}</strong>
                <span className={s.branchCheckAddr}>
                  Email со списком занятий на завтра
                </span>
              </span>
            </label>
          </li>
        ))}
      </ul>
    </>
  );

  if (compact) {
    return <HubFormCard title="Тренерам">{body}</HubFormCard>;
  }

  return (
    <section className={md.desktopSettingsNotifyCard}>
      <h3 className={md.desktopSettingsSubheading}>Тренерам</h3>
      {body}
    </section>
  );
}
